import handleProductTypeNavigation from './account_creation/handleProductTypeNavigation';
import handleAccountEmailNavigation from './account_creation/handleAccountEmailNavigation';
import handleAccountSubmission from './account_creation/handleAccountSubmission';
import handleBeforeRedirect from './account_creation/handleBeforeRedirect';
import handleMultiPathFormValidation from './account_creation/handleMultiPathFormValidation';
import reloadPage from './account_creation/reloadPage';

/**
  * Intercept navigation from various known steps and call handlers.
  * @param {Event} event - either mslf.beforeNavigation or mslf.beforeSubmit
  */
 export function handleNavigation(event) {
  switch(event.detail.currentPanel.dataset.id) {
    case 'product-type': return handleProductTypeNavigation(event);
    case 'account-email-panel': return handleAccountEmailNavigation(event);
    case 'account-panel': return handleAccountSubmission(event);
  }
}

document.addEventListener('mslf.beforeNavigation', handleNavigation);
document.addEventListener('mslf.beforeSubmit', handleNavigation);
document.addEventListener('mslf.beforeRedirect', handleBeforeRedirect);
document.addEventListener('mslf.afterNavigation', handleMultiPathFormValidation);
document.addEventListener('mslf.afterCreateUser', reloadPage);
